
import store from '@/store'
function checkPermission(permissionRoles, companyInfo = store.getters.companyInfo) {
  let hasPermission = false
  if (companyInfo && companyInfo.companyType) {
    const companyTypes = companyInfo.companyType
    hasPermission = permissionRoles.some(type => {
      return companyTypes.includes(type)
    })
  }
  return hasPermission
}
const permission = {
  install(Vue) {
    Vue.directive('permission', {
      inserted: function(el, binding) {
        const { value } = binding
        if (value && value instanceof Array) {
          if (value.length > 0) {
            const hasPermission = checkPermission(value)
            if (!hasPermission) {
              el.parentNode && el.parentNode.removeChild(el)
            }
          }
        } else {
          throw new Error(`need roles! Like v-permission="['admin','editor']"`)
        }
      }
    })
    Vue.prototype.$permission = checkPermission
  }
}

export { permission, checkPermission }
